import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {AppState} from 'store/customer/storeSetup';

const initialState: {progress: number | null} = {
    progress: null,
};

const productUploadSlice = createSlice({
    name: 'productUpload',
    initialState,
    reducers: {
        progressSet: (state, {payload}: PayloadAction<number | null>) => {
            state.progress = payload;
        },
    },
});

export const progressState = (store: AppState) => store.productUpload.progress;

export const {progressSet} = productUploadSlice.actions;

export default productUploadSlice.reducer;
